import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, Button, Box, TextField, Typography } from '@mui/material';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import { validateRequiredWithAsyncValidationEmail, validateRequiredEmail } from '../../../utils/validators';
import AgreeToTermsInfo from '../../terms/AgreeToTermsInfo';

const OnboardingUserForm = ({ disabled, onSubmit }) => (
  <Formik
    initialValues={{
      email: '',
    }}
    validate={async (values) => {
         const errors = {};
         const emailError = await validateRequiredWithAsyncValidationEmail('')(values.email);

         if (emailError) {
           errors.email = emailError;
         }

         return errors;
       }}
       onSubmit={onSubmit}
       validateOnChange={true}
       validateOnBlur={true}
  >
    {({ isSubmitting, handleSubmit, dirty }) => (
      <Form onSubmit={handleSubmit}>
        <Box
          sx={{
            maxWidth: 400,
            mx: 'auto',
            p: 3,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Field
            name="email"
            as={TextField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlined />
                </InputAdornment>
              ),
            }}
            label="Email"
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <ErrorMessage name="email" component={Typography} color="error" />

          <Box sx={{ mt: 2 }}>
            <AgreeToTermsInfo />
          </Box>

          <Box sx={{ mt: 2 }}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              disabled={isSubmitting || disabled}
            >
              Zarejestruj
            </Button>
          </Box>
        </Box>
      </Form>
    )}
  </Formik>
);

OnboardingUserForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  initialValues: PropTypes.shape({
    email: PropTypes.string,
  }),
};

export default OnboardingUserForm;